import { useMutation } from '@tanstack/react-query'
import { createApiCall } from 'services'

export type DeleteAccountResponse = {
  success: boolean
}

type DeleteAccountApiError = Error & {
  status?: number
}

const toMutationError = (status: number, fallbackMessage: string, message?: string): DeleteAccountApiError => {
  const error = new Error(message || fallbackMessage) as DeleteAccountApiError
  error.status = status
  return error
}

export const useDeleteAccountMutation = () => {
  const mutation = useMutation<DeleteAccountResponse, DeleteAccountApiError>({
    mutationFn: async () => {
      const response = await createApiCall({
        method: 'DELETE',
        url: '/auth/admin/account',
      })

      if (response.status !== 200) {
        throw toMutationError(
          response.status,
          'Failed to delete account',
          typeof response.data?.message === 'string' ? response.data.message : undefined
        )
      }

      return response.data as DeleteAccountResponse
    },
  })

  return {
    deleteAccount: mutation.mutate,
    deleteAccountAsync: mutation.mutateAsync,
    isDeletingAccount: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  }
}
